import { StringUtils } from '@/utils/policy/StringUtils'
import type { DataBlock } from 'de-zurich-ui-library'

export class ObjectUtils {
  public static isEmpty(obj: unknown): boolean {
    if (!obj) return true

    if (Array.isArray(obj)) {
      const containsAtLeastOneElement = obj.some((e) =>
        typeof e === 'object' ? Object.keys(e).length > 0 : Boolean(e)
      )
      return obj.length === 0 ? true : !containsAtLeastOneElement
    }

    switch (typeof obj) {
      case 'object':
        return Object.keys(obj as Record<string, unknown>).length === 0
      case 'string':
        return StringUtils.isEmpty(obj)
      default:
        return false
    }
  }

  public static isNotEmpty(obj: unknown): boolean {
    return !this.isEmpty(obj)
  }

  public static parseBoolean(obj: unknown): boolean {
    if (!obj) return false

    switch (typeof obj) {
      case 'boolean':
        return obj
      case 'string':
        return StringUtils.parseBoolean(obj)
      default:
        return false
    }
  }

  public static hasElementsToDisplay(dataBlocks: DataBlock[]): boolean {
    if (ObjectUtils.isEmpty(dataBlocks)) {
      return false
    }

    const flattenedDataBlockData = dataBlocks.flatMap((dataBlock) => dataBlock.data)

    const hasElementsThatShouldAlwaysBeDisplayed = flattenedDataBlockData.some(
      (singleBlock) => !Object.keys(singleBlock).includes('hide')
    )

    const hasElementsToDisplay = flattenedDataBlockData
      .filter((singleBlock) => Object.keys(singleBlock).includes('hide'))
      .some((singleBlock) => !singleBlock.hide)

    return hasElementsThatShouldAlwaysBeDisplayed ? true : hasElementsToDisplay
  }
}
